$(document).on('focus', '.document-issuer-autocomplete', function(e){
  $(this).autocomplete({ source: $(this).data('autocomplete-source'), minLength: 3 }).focus(function(){
    $(this).data("uiAutocomplete").search($(this).val());
  });
});

jQuery(document).ready(function() {
  $(document).on('close.fndtn.reveal', '#awardModal, #certificateModal, #companyDescriptionModal', function () {
    $(this).html("");
  });
})

function show_document_dialog(link, title){
  show_ajax_popup(link, title);
  $('#div_model_popup').ajaxComplete(function() {
    autoCompleteDocumentIssuer();
  });
}

function autoCompletePersonalIDIssuer(){
  $("#company_document_identity_issuer_name").autocomplete({ source:
    $('#company_document_identity_issuer_name').data('autocomplete-source')
  })
}

$(document).on('change','#license_proof, #identity_proof, #company_document_proof' , function() {
  $(this).attr('data-parsley-value', $(this).val());
});


function file_select_ie(){
  if (navigator.userAgent.indexOf("MSIE") > 0) {
   $('#document_doc').on('mousedown',function(event) {$(this).trigger('click');});
  }
}

$(document).on('change', "#company_document_form input[type=radio][name^='company_document']" , function() {
  if( $(this).val() === "Other"){
    $("#other").show();
    $('#other').addClass('required')
  }
  else{
    $('#other').removeClass('required')
    $("#other").hide();
  }
});
